<template>
  <header class="navbar navbar-light navbar-not-login-user">
    <div class="page-header-container clearfix">
      <div class="container">
        <a href="/" class="navbar-brand">
          <img src="../assets/images/enea.svg" alt="ENEA" class="img-fluid" />
        </a>
        <div class="navbar-brand-payment">
          <img src="../assets/images/logo-autopay.svg" alt="Autopay" width="160" height="40"/>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>
